import { render, staticRenderFns } from "./jilu.vue?vue&type=template&id=1b525948&scoped=true&"
import script from "./jilu.vue?vue&type=script&lang=js&"
export * from "./jilu.vue?vue&type=script&lang=js&"
import style0 from "./jilu.vue?vue&type=style&index=0&id=1b525948&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b525948",
  null
  
)

export default component.exports